import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { hasMessageContent, isMobileDevice, shouldSubmitOnEnter } from '../../../../utils/input-handling.utils';

@Component({
  selector: 'app-text-input',
  standalone: true,
  imports: [CommonModule, FormsModule, CdkTextareaAutosize],
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextInputComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() userMessage = '';
  @Input() placeholder = 'Ask me anything...';
  @Input() disabled = false;
  @Input() autoFocus = true;
  @Input() processing = false;

  @Output() userMessageChange = new EventEmitter<string>();
  @Output() submitMessage = new EventEmitter<void>();
  @Output() keydownEvent = new EventEmitter<KeyboardEvent>();

  @ViewChild('textInput') textInput!: ElementRef<HTMLTextAreaElement>;
  @ViewChild(CdkTextareaAutosize) autosize!: CdkTextareaAutosize;

  isMobile = isMobileDevice();

  ngOnInit(): void {
    // Component initialization
  }

  ngAfterViewInit(): void {
    if (this.autoFocus && !this.isMobile) {
      this.focusInput();
    }
    
    // Force resize to ensure proper initial height
    setTimeout(() => {
      if (this.autosize) {
        this.autosize.resizeToFitContent(true);
      }
    }, 0);
  }

  ngOnDestroy(): void {
    // Cleanup if needed
  }

  onKeydown(event: KeyboardEvent): void {
    this.keydownEvent.emit(event);

    if (shouldSubmitOnEnter(event) && !this.processing) {
      event.preventDefault();
      this.submitMessage.emit();
    }
  }

  onMessageChange(value: string): void {
    this.userMessage = value;
    this.userMessageChange.emit(value);
  }

  focusInput(): void {
    setTimeout(() => {
      this.textInput?.nativeElement?.focus();
    }, 200);
  }

  hasContent(): boolean {
    return hasMessageContent(this.userMessage);
  }

  clearInput(): void {
    this.userMessage = '';
    this.userMessageChange.emit('');
    
    // Resize textarea after clearing
    setTimeout(() => {
      if (this.autosize) {
        this.autosize.resizeToFitContent(true);
      }
    }, 0);
  }
}